import React from "react";
import DropDown from "../../../common/components/shared/dropDown/dropDown";
import Row from "../../../common/components/shared/row/row";
import TextInput from "../../../common/components/shared/textInput/textInput";
import {PackingModel} from "../../../dictionaries/models/packing";
import {UnCodeModelForDropdown} from "../../../dictionaries/models/unCode";
import {PackingService} from "../../../dictionaries/services/packingService";
import {UnCodeService} from "../../../dictionaries/services/unCodeService";
import i18n from "../../../i18n/i18n";
import {ITicketStore} from "../../stores/ticketStore";
import {PackingType} from "../../models/dangeresGoods";
import {ReactComponent as RemoveIcon} from "../../../statics/icons/icon_remove.svg";
import {IconButton} from "@mui/material";
import {DropDownUtils} from "../../../helpers/dropDownUtils";
import {IOrderStore} from "../../stores/orderStore";
import AutocompleteDropdown from "../../../common/components/shared/autocompleteDropdown/autocompleteDropdown";
import {AutocompleteDropDownUtils} from "../../../helpers/autocompleteDropDownUtils";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {Api} from "../../../helpers/api";

interface SingleDangerousGoodState {
    unCodes: UnCodeModelForDropdown[];
    packing: PackingModel[];
    packingResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    unCodesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

interface SingleDangerousGoodProps {
    dangerousGoodId: number;
    onRemoveAction: () => void;
    isDangerousGood: boolean;
    store: ITicketStore | IOrderStore;
}

export default class SingleDangerousGood extends React.Component <SingleDangerousGoodProps, SingleDangerousGoodState> {
    constructor(props: any) {
        super(props);

        this.state = {
            unCodes: [],
            packing: [],
            unCodesResponse: undefined,
            packingResponse: undefined
        };
    }

    async componentDidMount() {
        await this.getPacking();
        await this.getUnCodes();
    }

    render() {
        return (
            <div className="single-dangerous-good">
                <Row class="flex-type gap-20">
                    <AutocompleteDropdown
                        className="element"
                        label={i18n.t("transportation.ticket.details.dangerousGoods.properties.unCode")}
                        options={this.unCodesToDropdown()}
                        validatedValue={this.props.store.dangerousGoods[this.props.dangerousGoodId].unCodeId}
                        testId="dangerous-good-un-code"
                        error={!Api.isSuccess(this.state.unCodesResponse) ? i18n.t("errorMessages.unCodesErrorSuffix") : ""}
                        reloadFunc={() => this.getUnCodes()}
                        isNoRequired={!this.props.isDangerousGood}
                    />
                    <DropDown
                        className="element"
                        label={i18n.t("transportation.ticket.details.dangerousGoods.properties.packing")}
                        items={this.packingToDropdown()}
                        validatedValue={this.props.store.dangerousGoods[this.props.dangerousGoodId].packingId}
                        testId="dangerous-good-packing"
                        error={!Api.isSuccess(this.state.packingResponse) ? i18n.t("errorMessages.packingErrorSuffix") : ""}
                        reloadFunc={() => this.getPacking()}
                        isNoRequired={!this.props.isDangerousGood}
                    />
                    <TextInput
                        label={i18n.t("transportation.ticket.details.dangerousGoods.properties.packingQuantity")}
                        validatedValue={this.props.store.dangerousGoods[this.props.dangerousGoodId].packingQuantity}
                        testId="dangerous-good-packing-quantity"
                        offAutocomplete
                    />
                    <DropDown
                        className="element"
                        label={i18n.t("transportation.ticket.details.dangerousGoods.properties.packingGroup")}
                        items={this.packingGroupToDropdown()}
                        validatedValue={this.props.store.dangerousGoods[this.props.dangerousGoodId].packingGroup}
                        testId="dangerous-good-packing-group"
                    />
                    <TextInput
                        label={i18n.t("transportation.ticket.details.dangerousGoods.properties.weight")}
                        validatedValue={this.props.store.dangerousGoods[this.props.dangerousGoodId].weight}
                        testId="dangerous-good-weight"
                        unit="kg"
                        offAutocomplete
                    />
                    {this.renderRemoveButton()}
                </Row>
            </div>
        );
    }

    private renderRemoveButton() {
        if (this.props.isDangerousGood && this.props.dangerousGoodId === 0) {
            return;
        } else return (
            <IconButton
                className="remove-dangerous-good-btn"
                onClick={() => this.props.onRemoveAction()}
                data-testid={`remove-${this.props.dangerousGoodId}`}
            >
                <RemoveIcon/>
            </IconButton>
        );
    }

    private unCodesToDropdown() {
        const unCodes = this.state.unCodes.sort((a,b) => {
            return a.name.localeCompare(b.name);
        });

        if (!unCodes || (unCodes && typeof unCodes.map !== "function") || (unCodes && unCodes.length === 0)) {
            return [];
        }

        const autocomplete = unCodes.map((unCode) => ({
            id: unCode.id,
            label: `${unCode.name} (${unCode.code})`,
            renderOption: <><b>{unCode.code}</b> | {unCode.name}</>
        }));

        return AutocompleteDropDownUtils.listToAutocompleteDropDownMap(autocomplete, "id");
    }

    private packingToDropdown() {
        return DropDownUtils.listToDropDownMap(this.state.packing);
    }

    private packingGroupToDropdown() {
        return [
            {
                id: PackingType.I,
                name: PackingType.I
            },
            {
                id: PackingType.II,
                name: PackingType.II
            },
            {
                id: PackingType.III,
                name: PackingType.III
            }
        ];
    }

    private async getPacking() {
        const packingResponse = await PackingService.getAll();

        this.setState({
            packing: (packingResponse)?.data?.data || [],
            packingResponse
        });
    }

    private async getUnCodes() {
        const unCodesResponse = await UnCodeService.getActiveUnCodes();

        this.setState({
            unCodes: (unCodesResponse)?.data || [],
            unCodesResponse
        });
    }
}